import * as api from "services/api";

export const GET_CLIENT = "[CLIENT DETAIL] GET_CLIENT";
export const GET_CLIENT_SUCCESS = "[CLIENT DETAIL] GET_CLIENT_SUCCESS";
export const GET_CLIENT_FAILED = "[CLIENT DETAIL] GET_CLIENT_FAILED";

export const GET_CLIENT_CREDIT = "[CLIENT DETAIL] GET_CLIENT_CREDIT";
export const GET_CLIENT_CREDIT_SUCCESS =
	"[CLIENT DETAIL] GET_CLIENT_CREDIT_SUCCESS";
export const GET_CLIENT_CREDIT_FAILED =
	"[CLIENT DETAIL] GET_CLIENT_CREDIT_FAILED";

export const GET_CLIENT_USERS = "[CLIENT DETAIL] GET_CLIENT_USERS";
export const GET_CLIENT_USERS_SUCCESS =
	"[CLIENT DETAIL] GET_CLIENT_USERS_SUCCESS";
export const GET_CLIENT_USERS_FAILED =
	"[CLIENT DETAIL] GET_CLIENT_USERS_FAILED";

export const SET_CLIENT_MANAGER = "[CLIENT DETAIL] SET_CLIENT_MANAGER";

export function getClient(id) {
	return async (dispatch, getState) => {
		dispatch({
			type: GET_CLIENT
		});

		const { token } = getState().login;
		const headers = {
			Authorization: "Bearer " + token
		};

		try {
			// Call all endpoints in parallel
			const [clientResponse, ordersResponse, salesResponse, laundryOrdersResponse] = await Promise.all([
				api.sendGet("/client/v2/" + id, headers),
				api.sendGet("/client/v2/" + id + "/Orders", headers),
				api.sendGet("/client/v2/" + id + "/Sales", headers),
				api.sendGet("/client/v2/" + id + "/LaundryOrders", headers)
			]);

			if (clientResponse.ok) {
				let clientJson = await clientResponse.json();
				let client = clientJson.model;

				// Merge additional data if available
				if (ordersResponse.ok) {
					let ordersJson = await ordersResponse.json();
					client.orders = ordersJson.model || [];
				} else {
					client.orders = [];
				}

				if (salesResponse.ok) {
					let salesJson = await salesResponse.json();
					client.sales = salesJson.model || [];
				} else {
					client.sales = [];
				}

				if (laundryOrdersResponse.ok) {
					let laundryOrdersJson = await laundryOrdersResponse.json();
					client.laundryOrders = laundryOrdersJson.model || [];
				} else {
					client.laundryOrders = [];
				}

				dispatch({
					type: GET_CLIENT_SUCCESS,
					payload: client
				});
				return client;
			} else {
				dispatch({ type: GET_CLIENT_FAILED });
			}
		} catch (error) {
			dispatch({ type: GET_CLIENT_FAILED });
		}
	};
}

export function getClientCredit(id) {
	return async (dispatch, getState) => {
		dispatch({
			type: GET_CLIENT_CREDIT
		});

		const { token } = getState().login;

		let response = await api.sendGet("/client/" + id + "/credit", {
			Authorization: "Bearer " + token
		});

		if (response.ok) {
			let json = await response.json();

			let client = json.model;
			dispatch({
				type: GET_CLIENT_CREDIT_SUCCESS,
				payload: client
			});
		} else {
			dispatch({ type: GET_CLIENT_CREDIT_FAILED });
		}
	};
}


/** The logins of a client: a pousada has one per person who places orders. */
export function getClientUsers(id) {
	return async (dispatch, getState) => {
		dispatch({ type: GET_CLIENT_USERS });

		const { token } = getState().login;
		const headers = { Authorization: "Bearer " + token };

		try {
			const response = await api.sendGet("/Client/" + id + "/Users", headers);
			const json = await response.json();

			if (response.ok && json.isValid) {
				dispatch({ type: GET_CLIENT_USERS_SUCCESS, payload: json.model });
			} else {
				dispatch({ type: GET_CLIENT_USERS_FAILED });
			}
		} catch (error) {
			dispatch({ type: GET_CLIENT_USERS_FAILED });
		}
	};
}

const GENERIC_USER_ERROR =
	"Ocorreu um erro ao tentar enviar sua solicitação, tente novamente";

export function createClientUser(id, model, callback) {
	return async (dispatch, getState) => {
		const { token } = getState().login;
		const headers = { Authorization: "Bearer " + token };

		try {
			const response = await api.sendPost(
				"/Client/" + id + "/Users",
				model,
				headers
			);
			const json = await response.json();

			if (response.ok && json.isValid) {
				dispatch(getClientUsers(id));
				callback();
			} else {
				callback(json.errors ? json.errors.join() : GENERIC_USER_ERROR);
			}
		} catch (error) {
			callback(GENERIC_USER_ERROR);
		}
	};
}

/** Marks (or unmarks) the person responsible, who manages the team from the app. */
export function setClientManager(id, userId, manager, callback) {
	return async (dispatch, getState) => {
		dispatch({ type: SET_CLIENT_MANAGER });

		const { token } = getState().login;
		const headers = { Authorization: "Bearer " + token };

		try {
			const response = await api.sendPut(
				"/Client/" + id + "/Users/" + userId + "/Manager?manager=" + manager,
				null,
				headers
			);
			const json = await response.json();

			if (response.ok && json.isValid) {
				dispatch(getClientUsers(id));
				callback();
			} else {
				callback(json.errors ? json.errors.join() : GENERIC_USER_ERROR);
			}
		} catch (error) {
			callback(GENERIC_USER_ERROR);
		}
	};
}
